/*!
=========================================================
* Painel Toca da Onça — Agentes & IA
=========================================================
* Carmen já roda no JARVIS. Os demais ficam prontos pra ativar.
*/
import React from "react";
import { Card, CardBody, CardTitle, Button, Row, Col, Badge } from "reactstrap";

const agentes = [
  {
    nome: "Carmen — WhatsApp",
    icon: "fas fa-robot",
    cor: "#25d366",
    ativo: true,
    detalhe: "Atende, segmenta e reaquece leads. Rodando no JARVIS.",
  },
  {
    nome: "Agente RH",
    icon: "fas fa-user-tie",
    cor: "#8965e0",
    ativo: false,
    detalhe: "Triagem, recrutamento e treinamento de vendedoras.",
  },
  {
    nome: "Agente Fiscal",
    icon: "fas fa-file-invoice-dollar",
    cor: "#2dce89",
    ativo: false,
    detalhe: "Emissão de nota fiscal. Precisa do certificado A1/A3 + gov.br.",
  },
  {
    nome: "IA Nemotron (NVIDIA)",
    icon: "fas fa-brain",
    cor: "#76b900",
    ativo: false,
    detalhe: "Cérebro de IA pros agentes. Precisa da chave da NVIDIA.",
  },
  {
    nome: "Agente Caixa",
    icon: "fas fa-cash-register",
    cor: "#fb6340",
    ativo: false,
    detalhe: "Fecha o caixa e calcula lucro líquido por venda.",
  },
  {
    nome: "Agente CNPJ / Prospecção",
    icon: "fas fa-search-dollar",
    cor: "#11cdef",
    ativo: false,
    detalhe: "Busca dados públicos de CNPJ e prospecta fornecedores.",
  },
];

function Agentes() {
  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>
            Agentes &amp; Inteligência Artificial
          </h3>
          <p className="text-muted">
            Sua equipe de robôs. A Carmen já trabalha. Os demais estão montados — ativar
            alguns depende de chave/login (marcado em cada card).
          </p>
        </Col>
      </Row>
      <Row>
        {agentes.map((a, i) => (
          <Col lg="4" md="6" key={i}>
            <Card style={{ minHeight: "200px" }}>
              <CardBody>
                <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 12 }}>
                  <div
                    style={{
                      width: 54,
                      height: 54,
                      borderRadius: 14,
                      background: a.cor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <i className={a.icon} style={{ fontSize: 24, color: "#fff" }} />
                  </div>
                  <div>
                    <CardTitle tag="h4" className="text-white" style={{ margin: 0 }}>
                      {a.nome}
                    </CardTitle>
                    {a.ativo ? (
                      <Badge color="success" pill>● Ativo</Badge>
                    ) : (
                      <Badge color="warning" pill>○ Pronto pra ativar</Badge>
                    )}
                  </div>
                </div>
                <p className="text-muted" style={{ minHeight: 44 }}>{a.detalhe}</p>
                {a.ativo ? (
                  <Button color="success" size="sm" outline disabled>Rodando</Button>
                ) : (
                  <Button color="info" size="sm">Ativar</Button>
                )}
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default Agentes;
